import { SaisieSignature } from 'src/app/core/models/form-state.model';
import { BaseComponent } from 'src/app/shared/components/base-component/base-component.component';
import { Component, ElementRef, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { InfoTopVM } from 'src/app/shared/models/components/infotopVm';
import { QuestionVM } from 'src/app/shared/models/components/questionVm';
import { HeaderVM } from 'src/app/shared/models/components/headerVm';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppResource } from 'src/app/app.resource';
import { SignatureVM } from 'src/app/shared/models/components/signatureVm';
import { ElectronicSignatureEnum } from 'src/app/shared/models/enum/electronicsignature.enum';
import { Store } from '@ngrx/store';
import { State } from 'src/app/core/state/core.state';
import { Contract } from 'src/app/core/models/form-state.model';
import { DomSanitizer } from '@angular/platform-browser';
import * as fromContext from 'src/app/core/state/context';
import * as fromContract from 'src/app/core/state/contract';
import * as fromElectronicSignature from 'src/app/core/state/electronic-signature';
import * as fromPayment from 'src/app/core/state/payment';
import * as fromInfo from 'src/app/core/state/info';
import * as fromPath from '../../../core/state/path';
import { MatomoTracker } from 'ngx-matomo-client';
import { SignatureService } from 'src/app/api/services/signature.service';
import { ApiRequestBodyUtils } from 'src/app/shared/utils/apiRequestBodyUtils';
import { lastValueFrom, take } from 'rxjs';
import { Stepper } from 'src/app/core/models/stepper.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { PDFProgressData } from 'ng2-pdf-viewer';
import { PathType } from 'src/app/core/enums/path-type.enum';
import { AppConfig } from 'src/app/app.config';
import { isMobile } from 'src/app/shared/utils/deviceUtils';

@Component({
  selector: 'app-electronic-signature',
  templateUrl: './electronic-signature.component.html',
  styleUrls: ['./electronic-signature.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ElectronicSignatureComponent extends BaseComponent implements OnInit {
  headerStep!: HeaderVM;
  infoTop!: InfoTopVM;
  override question!: QuestionVM;
  stepB: boolean = false;

  electronicSignatureEnum = ElectronicSignatureEnum;
  signatureVm!: SignatureVM;

  condPCheck: boolean = false;
  infoCheck: boolean = false;
  sepaCheck: boolean = false;

  isChecked: boolean = false;

  context!: string;
  contrat!: Contract;
  path!: PathType;
  sansEffetPhoneNumber: string = '';

  //Style
  condP: boolean = true;
  infoB: boolean = false;
  sepa: boolean = false;
  numericCodeForm!: FormGroup;

  isLoading: boolean = false;
  displayError: boolean = false;
  displayErrorText: boolean = false;

  displayModal: boolean = false;
  titleModal!: string;
  descriptionModal!: string;

  errorCodeSMS: string[] = [];
  showCantSignModal: boolean = false;

  get NOne() {
    return this.numericCodeForm.get('NOne');
  }

  get NTwo() {
    return this.numericCodeForm.get('NTwo');
  }

  get NThree() {
    return this.numericCodeForm.get('NThree');
  }

  get NFour() {
    return this.numericCodeForm.get('NFour');
  }

  get NFive() {
    return this.numericCodeForm.get('NFive');
  }

  get NSix() {
    return this.numericCodeForm.get('NSix');
  }

  get brand() {
    return this.appConfig.getConfig('brand');
  }

  constructor(
    private spinner: NgxSpinnerService,
    store: Store<State>,
    resources: AppResource,
    tracker: MatomoTracker,
    private router: Router,
    private sanitizer: DomSanitizer,
    private elementRef: ElementRef,
    private signatureService: SignatureService,
    @Inject(AppConfig) private appConfig: AppConfig
  ) {
    super(store, resources, tracker);

    this.headerStep = new HeaderVM(
      this.brand === 'HM' ? this.resource.header.stepContract : this.resource.header.stepSignature,
      3,
      this.resource.header.subStepSignature,
      9
    );
  }

  override async ngOnInit() {
    super.ngOnInit();
    this.spinner.show();
    this.initForm();

    await this.loadStateData();

    this.initVm();

    this.getSansEffetPhoneNumber();
  }

  private initForm() {
    this.numericCodeForm = new FormGroup({
      NOne: new FormControl<number | null>(null, {
        validators: [Validators.required, Validators.maxLength(1), Validators.pattern('^[0-9]*$')],
        nonNullable: true
      }),
      NTwo: new FormControl<number | null>(null, {
        validators: [Validators.required, Validators.maxLength(1), Validators.pattern('^[0-9]*$')],
        nonNullable: true
      }),
      NThree: new FormControl<number | null>(null, {
        validators: [Validators.required, Validators.maxLength(1), Validators.pattern('^[0-9]*$')],
        nonNullable: true
      }),
      NFour: new FormControl<number | null>(null, {
        validators: [Validators.required, Validators.maxLength(1), Validators.pattern('^[0-9]*$')],
        nonNullable: true
      }),
      NFive: new FormControl<number | null>(null, {
        validators: [Validators.required, Validators.maxLength(1), Validators.pattern('^[0-9]*$')],
        nonNullable: true
      }),
      NSix: new FormControl<number | null>(null, {
        validators: [Validators.required, Validators.maxLength(1), Validators.pattern('^[0-9]*$')],
        nonNullable: true
      })
    });
  }

  private async loadStateData() {
    // Retrieve context
    let contextId = await lastValueFrom(
      this.store.select(fromContext.selectContextId).pipe(take(1))
    );
    this.context = contextId!;

    // Retrieve contract
    this.contrat = await lastValueFrom(
      this.store.select(fromContract.selectContractState).pipe(take(1))
    );

    this.path = await lastValueFrom(this.store.select(fromPath.selectPathType).pipe(take(1)));

    this.store.select(fromElectronicSignature.selectElectronicSignature).subscribe(res => {
      this.condPCheck = res.electronicSignature.AcceptationCP;
      this.infoCheck = res.electronicSignature.AcceptationFIC;
      this.sepaCheck = res.electronicSignature.AcceptationMandatSEPA;
    });
  }

  private async initVm() {
    if (this.contrat) {
      this.signatureVm = new SignatureVM(
        this.contrat.RefDocumentCP,
        this.contrat.RefDocumentFIC,
        this.contrat.RefDocumentMandatSEPA
      );
    } else {
      this.signatureVm = new SignatureVM('', '', '');
    }

    const payment = await lastValueFrom(this.store.select(fromPayment.selectPayment).pipe(take(1)));

    this.infoTop = new InfoTopVM(
      this.resource.infotop.codeConfirmation,
      this.resource.infotop.codeConfirmationS,
      payment.payment.Telephone,
      this.resource.infotop.logoMessage,
      true
    );

    this.question = new QuestionVM(this.resource.question.signature1);
  }
  updateChecks() {
    this.condPCheck = this.isChecked;
    this.infoCheck = this.isChecked;
    this.sepaCheck = this.isChecked;
  }

  getSansEffetPhoneNumber() {
    if (this.path === PathType.HOUSING) {
      this.sansEffetPhoneNumber = this.resource.signature.phoneNumberHousing;
    } else if (this.path === PathType.HOUSING_PARIS) {
      this.sansEffetPhoneNumber = this.resource.signature.phoneNumberHousingParis;
    } else if (this.path === PathType.HOUSING_SOLIDARITY) {
      this.sansEffetPhoneNumber = this.resource.signature.phoneNumberHousingSolidarity;
    }
  }

  validateStepOne() {
    if (this.cantTriggerSignature()) {
      this.showCantSignModal = true;
      return;
    }
    this.isLoading = true;

    const saisieSignature: SaisieSignature = {
      AcceptationCP: this.condPCheck,
      AcceptationFIC: this.infoCheck,
      AcceptationMandatSEPA: this.sepaCheck
    };

    this.store.dispatch(
      fromElectronicSignature.patchSignature({
        payload: saisieSignature
      })
    );

    // Create signature
    const bodyCreateSignature = ApiRequestBodyUtils.GenerateSignatureCreateRequestBody(
      this.context,
      this.contrat.NumeroContrat,
      saisieSignature
    );

    this.signatureService.createSignature(bodyCreateSignature).subscribe({
      next: resSignature => {
        // Save returned token in state
        this.store.dispatch(
          fromElectronicSignature.patchSignature({
            payload: {
              SignatureToken: resSignature.TokenSignature
            }
          })
        );

        this.question = new QuestionVM(this.resource.question.signature2);
        this.stepB = true;
      },
      error: () => {
        this.isLoading = false;
        this.displayError = true;
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  sendBackSmsCode() {
    this.displayModal = true;
    this.titleModal = this.resource.signature.sendBackSmsCodeTitle;
    this.descriptionModal = this.resource.signature.sendBackSmsCode;

    const saisieSignature: SaisieSignature = {
      AcceptationCP: this.condPCheck,
      AcceptationFIC: this.infoCheck,
      AcceptationMandatSEPA: this.sepaCheck
    };

    // Create signature
    const bodyCreateSignature = ApiRequestBodyUtils.GenerateSignatureCreateRequestBody(
      this.context,
      this.contrat.NumeroContrat,
      saisieSignature
    );

    this.signatureService.createSignature(bodyCreateSignature).subscribe({
      next: resSignature => {
        // Save returned token in state
        this.store.dispatch(
          fromElectronicSignature.patchSignature({
            payload: {
              SignatureToken: resSignature.TokenSignature
            }
          })
        );
      },
      error: () => {
        this.displayError = true;
      }
    });
  }

  async validateStepTwo() {
    this.isLoading = true;

    const codeSms: string =
      this.NOne?.value +
      this.NTwo?.value +
      this.NThree?.value +
      this.NFour?.value +
      this.NFive?.value +
      this.NSix?.value;

    this.store.dispatch(
      fromElectronicSignature.patchSignature({
        payload: {
          CodeSms: codeSms
        }
      })
    );

    this.store.dispatch(
      fromElectronicSignature.changeValidationStatus({
        isValid: true
      })
    );

    // Retrieve signature state
    const signatureState = await lastValueFrom(
      this.store.select(fromElectronicSignature.selectElectronicSignature).pipe(take(1))
    );

    // Validate signature
    const bodySignDocuments = ApiRequestBodyUtils.GenerateSignatureSignRequestBody(
      this.context,
      this.contrat.NumeroContrat,
      signatureState.electronicSignature
    );

    console.log('bodySignDocuments', bodySignDocuments);

    this.signatureService.signDocuments(bodySignDocuments).subscribe({
      next: () => {
        this.router.navigate(['/confirmcontract']);
      },
      error: resSignature => {
        this.isLoading = false;
        if (resSignature.error?.status === 400) {
          let errorMessage = String(resSignature.error.detail).replace('"', '').replace('"', '');
          this.errorCodeSMS = errorMessage.split(':');
          this.displayErrorText = true;
        } else {
          this.displayError = true;
        }

        this.NOne?.setValue('');
        this.NTwo?.setValue('');
        this.NThree?.setValue('');
        this.NFour?.setValue('');
        this.NFive?.setValue('');
        this.NSix?.setValue('');
      },
      complete: () => {
        this.isLoading = false;
        this.displayError = false;
        this.displayErrorText = false;
        this.updateStepper();
      }
    });
  }

  updateClickButton(value: string) {
    switch (value) {
      case ElectronicSignatureEnum.CondP:
        if (!this.condP) {
          this.condP = !this.condP;
          this.infoB = false;
          this.sepa = false;
        }
        break;
      case ElectronicSignatureEnum.Info:
        if (!this.info) {
          this.condP = false;
          this.infoB = !this.info;
          this.sepa = false;
        }
        break;
      case ElectronicSignatureEnum.Sepa:
        if (!this.sepa) {
          this.condP = false;
          this.infoB = false;
          this.sepa = !this.sepa;
        }
        break;
    }
  }

  onKeyUp(event: any, nextValue: string) {
    const input = event.target;
    if (isNaN(input.value)) {
      input.value = '';
      return;
    }
    var nbVal = parseInt(input.value);
    if (nbVal < 0 || nbVal > 9) {
      input.value = '';
      return;
    }
    this.elementRef.nativeElement.querySelector('#' + nextValue).focus();
  }

  urlSafe(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  onProgress(progressData: any, documentType: ElectronicSignatureEnum) {
    this.spinner.show();
    if (progressData.loaded == progressData.total) {
      this.spinner.hide();
      switch (documentType) {
        case ElectronicSignatureEnum.CondP:
          this.signatureVm.condPLoaded = true;
          break;
        case ElectronicSignatureEnum.Info:
          this.signatureVm.infoLoaded = true;
          break;
        case ElectronicSignatureEnum.Sepa:
          this.signatureVm.sepaLoaded = true;
          break;
      }
    }
  }

  async updateStepper() {
    let stepper = await lastValueFrom(this.store.select(fromInfo.selectStepper).pipe(take(1)));
    var tmpStepper = JSON.parse(JSON.stringify(stepper)) as Stepper;

    let title = tmpStepper.contract.titles.find(
      (x: { libelle: string }) => x.libelle == this.resource.stepper.signature
    );

    let subtitleS = title?.subtitles.find(
      (x: { url: string }) => x.url == this.resource.stepper.electronicsignature
    );

    if (subtitleS) {
      subtitleS.isValid = true;
      subtitleS.isActive = true;
    }

    let subtitleNS = title?.subtitles.find(
      (x: { url: string }) => x.url == this.resource.stepper.confirmcontract
    );

    if (subtitleNS) {
      subtitleNS.isValid = true;
      subtitleNS.isActive = true;
    }

    this.store.dispatch(fromInfo.updateStepper({ payload: tmpStepper }));
  }

  confirmModal() {
    this.displayModal = false;
    this.showCantSignModal = false;
  }

  getClass(value: boolean) {
    return value ? 'active-ES' : 'inactive-ES';
  }

  cantTriggerSignature(): boolean {
    return (
      !this.condPCheck ||
      !this.infoCheck ||
      !this.sepaCheck ||
      !this.signatureVm.condPLoaded ||
      !this.signatureVm.infoLoaded ||
      !this.signatureVm.sepaLoaded
    );
  }

  onCpPdfError(error: any): void {
    console.error(error);
    this.signatureVm.condPLoaded = false;
    this.signatureVm.condPUrlEmbed = '';
    this.spinner.hide();
  }

  onFicPdfError(error: any): void {
    console.log(error);
    this.signatureVm.infoLoaded = false;
    this.signatureVm.infoUrlEmbed = '';
    this.spinner.hide();
  }

  onMandatSepaPdfError(error: any): void {
    console.log(error);
    this.signatureVm.sepaLoaded = false;
    this.signatureVm.sepaUrlEmbed = '';
    this.spinner.hide();
  }

  callClientService(): void {
    if (isMobile()) {
      var supportPhoneNumber =
        this.brand === 'Vyv'
          ? this.sansEffetPhoneNumber.replace(/\s/g, '')
          : this.resource.signature.clientServicePhoneNumber;
      window.location.href = `tel:${supportPhoneNumber}`;
    }
  }
}
